export default "__VITE_ASSET__506ac8cb__"